import { render, staticRenderFns } from "./404-not-found.vue?vue&type=template&id=6075f6ed"
import script from "./404-not-found.vue?vue&type=script&lang=js"
export * from "./404-not-found.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports